<!--  -->
<template>
  <div>
    <div class="search_box">
      <el-input
        v-model="pageIfonone.keyword"
        style="width:200px;margin-right:10px"
        placeholder="请输入appid/名称"
      />
      <el-select
        v-model="pageIfonone.mini_program_type"
        disabled
        placeholder="请选择小程序类型"
      >
        <el-option
          v-for="item in options"
          :key="item.mini_program_type"
          :label="item.type_name"
          :value="item.mini_program_type"
        />
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="search"
      >搜索</el-button>
      <el-button
        type="info"
        icon="el-icon-refresh"
        @click="reast"
      >重置</el-button>
    </div>

    <el-table
      :data="tableData"
      style="width: 100%"
    >
      <el-table-column
        prop="app_id"
        label="小程序appid"
        width="180"
        align="center"
      />
      <el-table-column
        prop="account_name"
        label="小程序名称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="account_name"
        label="小程序状态"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <span
            v-if="scope.row.punish_status === 'normal'"
            class="status-tag"
            style="color:#00b42a;background-color:#e8ffea;"
          >
            {{ scope.row.punish_status_text }}
          </span>

          <span
            v-else-if="scope.row.punish_status === 'auto_unlocked'"
            class="status-tag"
            style="color:#4a82ff;background-color:#e8f3ff;"
          >
            {{ scope.row.punish_status_text }}
          </span>

          <span
            v-else-if="scope.row.punish_status === 'appeal_processing'"
            class="status-tag"
            style="color:#ff9c3a;background-color:#fff7e8;"
          >
            {{ scope.row.punish_status_text }}
          </span>

          <span
            v-else-if="scope.row.punish_status === 'appeal_approved'"
            class="status-tag"
            style="color:#00b42a;background-color:#e8ffea;"
          >
            {{ scope.row.punish_status_text }}
          </span>

          <span
            v-else-if="scope.row.punish_status === 'appeal_rejected'"
            class="status-tag"
            style="color:#f53f3f;background-color:#ffece8;"
          >
            {{ scope.row.punish_status_text }}
          </span>

          <span
            v-else-if="scope.row.punish_status === 'appeal_cancelled'"
            class="status-tag"
            style="color:#4e5969;background-color:#f2f3f5;"
          >
            {{ scope.row.punish_status_text }}
          </span>

          <span
            v-else-if="scope.row.punish_status === 'can_appeal'"
            class="status-tag"
            style="color:#4e5969;background-color:#f2f3f5;"
          >
            {{ scope.row.punish_status_text }}
          </span>

          <span
            v-else-if="scope.row.punish_status === 'auto_unlocking'"
            class="status-tag"
            style="color:#ff7d00;background-color:#fff7e8;"
          >
            {{ scope.row.punish_status_text }}
          </span>

          <span
            v-else-if="scope.row.punish_status === 'punishing'"
            class="status-tag"
            style="color:#f53f3f;background-color:#ffece8;"
          >
            {{ scope.row.punish_status_text }}
          </span>

          <span
            v-else-if="scope.row.punish_status === 'warning'"
            class="status-tag"
            style="color:#fff;background-color:#e6a23c;"
          >
            {{ scope.row.punish_status_text }}
          </span>

          <!-- ✅ 兜底：不属于以上任何状态 -->
          <span
            v-else
            class="status-tag"
            style="color:#fff;background-color:#e6a23c;"
          >
            {{ scope.row.punish_status_text || '未知状态' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="countdown_seconds"
        label="封禁时间"
        width="200"
        align="center"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.punish_status === 'punishing'" style="color: #ff7d00;background-color: #fff7e8;padding: 5px 0px;">
            剩余{{ formatCountdown(scope.row.countdown_seconds) }}
          </div>
          <span
            v-else
            class="ban-tag"
          >
            --
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="accountName"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <!-- 1. 正常状态：不显示 -->
          <template v-if="scope.row.punish_status === 'normal'">
            <!-- 不显示按钮 -->
          </template>

          <!-- 2. 已自动解封：不显示 -->
          <template v-else-if="scope.row.punish_status === 'auto_unlocked'">
            <!-- 不显示按钮 -->
          </template>

          <!-- 3. 申诉处理中：显示，不可点 -->
          <!-- <el-button
            v-else-if="scope.row.punish_status === 'appeal_processing'"
            size="mini"
            type="info"
            disabled
          >
            {{ scope.row.appeal_button_text }}
          </el-button> -->

          <!-- 4. 申诉通过：显示，不可点 -->
          <!-- <el-button
            v-else-if="scope.row.punish_status === 'appeal_approved'"
            size="mini"
            type="info"
            disabled
          >
            {{ scope.row.appeal_button_text }}
          </el-button> -->

          <!-- 5. 申诉不通过：显示，不可点 -->
          <!-- <el-button
            v-else-if="scope.row.punish_status === 'appeal_rejected'"
            size="mini"
            type="info"
            disabled
          >
            {{ scope.row.appeal_button_text }}
          </el-button> -->

          <!-- 6. 申诉已撤销：显示，不可点 -->
          <!-- <el-button
            v-else-if="scope.row.punish_status === 'appeal_cancelled'"
            size="mini"
            type="info"
            disabled
          >
            {{ scope.row.appeal_button_text }}
          </el-button> -->

          <!-- 7. 可申诉：显示，可点击 -->
          <el-button
            v-if="scope.row.punish_status === 'can_appeal'"
            type="text"
            @click="handleAppeal(scope.row)"
          >
            {{ scope.row.appeal_button_text }}
          </el-button>

          <!-- 8. 等待自动解封：显示，不可点 -->
          <!-- <el-button
            v-else-if="scope.row.punish_status === 'auto_unlocking'"
            size="mini"
            type="warning"
            disabled
          >
            {{ scope.row.appeal_button_text }}
          </el-button> -->

          <!-- 9. 封禁中 -->
          <!-- <el-button
            v-else-if="scope.row.punish_status === 'punishing'"
            size="mini"
            type="danger"
            disabled
          >
            {{ scope.row.appeal_button_text }}
            <span v-if="scope.row._countdown > 0">
              （{{ formatCountdown(scope.row._countdown) }}）
            </span>
            <span v-if="scope.row.countdown_seconds > 0">
              （{{ formatCountdown(scope.row.countdown_seconds) }}）
            </span>
          </el-button> -->
          <!-- <el-button
            v-if="scope.row.is_selectable == true"
            type="text"
            size="mini"
            @click="chooser(scope.row)"
          >
            选择
          </el-button>
          <el-tooltip
            v-else
            content="小程序封禁暂不可选！"
            placement="right"
          >
            <el-button
              type="text"
              disabled
            >
              选择
            </el-button>
          </el-tooltip> -->
          <el-button
            type="text"
            size="mini"
            @click="chooser(scope.row)"
          >
            选择
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { /* programlist, */ appletlistrw, mptypeslist } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { getInfo } from '@/api/user'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      pageIfonone: {
        page: 1,
        page_size: 10,
        keyword: null,
        mini_program_type: 88
      },
      tableData: [],
      total: null,
      options: [],
      userIfon: {}
    }
  },
  created() {},
  mounted() {},
  beforeDestroy() {
    console.log('清空')
    this.tableData.forEach(row => {
      if (row._timer) {
        clearInterval(row._timer)
        row._timer = null
      }
    })
  },
  methods: {
    send() {
      this.getprogramlist()
      this.getapplettype()
      // this.usedinfo()
    },
    usedinfo() {
      getInfo().then((data) => {
        console.log('this.userIfon', this.userIfon)
        this.userIfon = data.data
      })
    },
    async getapplettype() {
      const data = await mptypeslist()
      this.options = data.data.types
      console.log('data', data)
    },
    // 获取绑定列表
    async getprogramlist() {
      // const data = await programlist(this.pageIfonone)
      const data = await appletlistrw(this.pageIfonone)
      this.tableData = data.data.list
      this.total = data.data.total
      // this.tableData.forEach(row => {
      //   if (row.punish_status === 'punishing') {
      //     this.startPunishCountdown(row)
      //   }
      // })
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfonone.pageSize = e
      this.getprogramlist()
    },
    fetchCurrentPage(e) {
      this.pageIfonone.page = e
      this.getprogramlist()
    },
    startPunishCountdown(row) {
    // 防止重复启动
      if (row._timer) return

      const seconds = Number(row.countdown_seconds)

      if (!seconds || seconds <= 0) return

      // 初始化倒计时
      this.$set(row, '_countdown', seconds)

      row._timer = setInterval(() => {
        row._countdown--

        if (row._countdown <= 0) {
          clearInterval(row._timer)
          row._timer = null
          row._countdown = 0 // 最终显示 0s 或直接消失
          this.getprogramlist()
        }
      }, 1000)
    },
    // formatCountdown(seconds) {
    //   seconds = Number(seconds)

    //   if (seconds < 60) {
    //     return `${seconds}s`
    //   }

    //   const minutes = Math.floor(seconds / 60)
    //   const remainSeconds = seconds % 60

    //   if (minutes < 60) {
    //     return remainSeconds > 0
    //       ? `${minutes}m ${remainSeconds}s`
    //       : `${minutes}m`
    //   }

    //   const hours = Math.floor(minutes / 60)
    //   const remainMinutes = minutes % 60

    //   return remainMinutes > 0
    //     ? `${hours}h ${remainMinutes}m`
    //     : `${hours}h`
    // },
    // formatCountdown(seconds) {
    //   seconds = Number(seconds)

    //   if (seconds < 60) {
    //     return `${seconds}s`
    //   }

    //   const minutes = Math.floor(seconds / 60)
    //   const remainSeconds = seconds % 60

    //   if (minutes < 60) {
    //     return remainSeconds > 0
    //       ? `${minutes}m ${remainSeconds}s`
    //       : `${minutes}m`
    //   }

    //   const hours = Math.floor(minutes / 60)
    //   const remainMinutes = minutes % 60

    //   return remainSeconds > 0
    //     ? `${hours}h ${remainMinutes}m ${remainSeconds}s`
    //     : `${hours}h ${remainMinutes}m`
    // },
    formatCountdown(seconds) {
      seconds = Number(seconds)
      if (!seconds || seconds <= 0) return '0s'

      const result = []

      const day = Math.floor(seconds / 86400)
      seconds %= 86400

      const hour = Math.floor(seconds / 3600)
      seconds %= 3600

      const minute = Math.floor(seconds / 60)
      // const second = seconds % 60

      if (day > 0) result.push(`${day}天`)
      if (hour > 0) result.push(`${hour}小时`)
      if (minute > 0) result.push(`${minute}分`)
      // if (second > 0) result.push(`${second}秒`)

      return result.join(' ')
    },
    chooser(row) {
      console.log('row', row)
      this.$emit('callback', row)
    },
    search() {
      this.getprogramlist()
    },
    reast() {
      this.pageIfonone.page = 1
      this.pageIfonone.page_size = 10
      this.pageIfonone.keyword = null
      // this.pageIfonone.mini_program_type = null
      this.getprogramlist()
    },
    handleAppeal(item) {
      console.log(item)
      const url = item.unlock_guide
      window.open(url, '_blank')
    },
    clearTimer() {
      console.log('清空')
      // this.tableData.forEach(row => {
      //   if (row._timer) {
      //     clearInterval(row._timer)
      //     row._timer = null
      //   }
      // })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.search_box {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.ban-tag {
  display: inline-block;
  min-width: 50px;
  height: 22px;          /* 👈 强制高度 */
  line-height: 22px;     /* 👈 垂直居中 */
  padding: 0 6px;        /* 👈 横向 padding */
  font-size: 12px;
  border-radius: 2px;
  box-sizing: border-box;
}

.ban-tag--warning {
  color: #ff7d00;
  background-color: #fff7e8;
}

.ban-tag--success {
  color: #00b42a;
  background-color: #e8ffea;
}
.status-tag {
  display: inline-block;     /* 👈 核心 */
  padding: 2px 8px;
  font-size: 12px;
  line-height: 18px;
  border-radius: 2px;
  white-space: nowrap;       /* 不换行 */
}
</style>
